gsap.registerPlugin(ScrollTrigger);
/* ======================================================== */
/* STICKY HEADER */
/* ======================================================== */
ScrollTrigger.matchMedia({
  "(min-width: 990px)": function() {
  // =====
const cobaltStickyHeader = gsap.from('.header-wrapper', { 
  yPercent: -100,
  paused: true,
  duration: 0.3
}).progress(1);
ScrollTrigger.create({
  start: "top top",
  end: 99999,
  onUpdate: (self) => {
    self.direction === -1 ? cobaltStickyHeader.play() : cobaltStickyHeader.reverse()
  }
});
  // =====
  }
});
/* ======================================================== */
/* STICKY LOGO */
/* ======================================================== */
/*
ScrollTrigger.create({
  // markers: true,
  trigger: "body",
  start: "1px top",
  end: "bottom top",
  toggleClass: {targets: ".co-home-hero-sticky-wrapper", className: "co-active"}
});
*/
ScrollTrigger.matchMedia({
  "(min-width: 768px)": function() {
  // =====
      gsap.set('.co-home-hero-sticky-wrapper', {
          // scale: 1,
          transformOrigin:"left bottom",
          width: "25%",
          left: "1%",
          bottom: "1%"
        });
    ScrollTrigger.create({
      trigger: "body",
      start: "1px top",
      end: "bottom top",
      onEnter: () => {
          let coHeroStickyLogoTl = gsap.timeline({defaults: {overwrite: true}});
          coHeroStickyLogoTl.to('.co-home-hero-sticky-wrapper', {
            width: "10%",
            ease: "expo.inOut",
            left: "1%",
            bottom: "1%",
            duration: 0.4
          });                                           
      },
      onLeaveBack: () => {
          let coHeroStickyLogoTl = gsap.timeline({defaults: {overwrite: true}});
          coHeroStickyLogoTl.to('.co-home-hero-sticky-wrapper', {
            ease: "expo.inOut",
            width: "25%",
            left: "1%",
            bottom: "1%",
            duration: 0.4
          });
      }
    });
  // =====
  }
});
// ScrollTrigger.matchMedia({
//   "(max-width: 767px)": function() {
//   // =====
//     gsap.set('.co-home-hero-sticky-wrapper', {
//           // scale: 1,
//           transformOrigin:"left bottom",
//           width: "40%",
//           left: "1%",
//           bottom: "1%"
//         });
//     ScrollTrigger.create({
//       trigger: "body",
//       start: "1px top",
//       end: "bottom top",
//       onEnter: () => {
//           let coHeroStickyLogoTl = gsap.timeline({defaults: {overwrite: true}});
//           coHeroStickyLogoTl.to('.co-home-hero-sticky-wrapper', {
//             width: "40%",
//             ease: "expo.inOut",
//             left: "1%",
//             bottom: "1%",
//             duration: 0.4
//           });                                           
//       },
//       onLeaveBack: () => {
//           let coHeroStickyLogoTl = gsap.timeline({defaults: {overwrite: true}});
//           coHeroStickyLogoTl.to('.co-home-hero-sticky-wrapper', {
//             ease: "expo.inOut",
//             width: "40%",
//             left: "1%",
//             bottom: "1%",
//             duration: 0.4
//           });
//       }
//     });
//   // =====
//   }
// });

/* ======================================================== */
/* HOME HERO RIGHT AND LEFT IMAGES */
/* ======================================================== */
/*
gsap.to('.co-home-hero-left-wrapper-img', {
    scrollTrigger: {
    trigger: "#co-home-hero-id",
    start: "top top",
    end: "bottom top",
    scrub: true
  },
  yPercent: -5
});
*/
gsap.to('.co-home-hero-right-wrapper-img', {
    scrollTrigger: {
    trigger: "#co-home-hero-id",
    start: "top top",
    end: "bottom top",
    scrub: true
  },
  scale: 1.1,
  transformOrigin: "left top"
});
/* ======================================================== */
/* SECTION TWO */
/* ======================================================== */
let coSectionTwoTl = gsap.timeline();
coSectionTwoTl.fromTo('.co-home-section-two-h3-span-1', {
  yPercent: 150,
  duration: 0.6
},
{
  yPercent: 0,
  duration: 0.6
});
coSectionTwoTl.fromTo('.co-home-section-two-h3-span-2', {
  yPercent: 150,
  duration: 0.6
},
{
  yPercent: 0,
  duration: 0.6
}, "-=0.5");
coSectionTwoTl.fromTo('.co-home-section-two-h3-span-3', {
  yPercent: 150,
  duration: 0.6
},
{
  yPercent: 0,
  duration: 0.6
}, "-=0.5");
coSectionTwoTl.fromTo('.co-home-section-two-h3-span-4', {
  yPercent: 150,
  duration: 0.6
},
{
  yPercent: 0,
  duration: 0.6
}, "-=0.5");
coSectionTwoTl.fromTo('.co-home-section-two-h3-span-5', {
  yPercent: 150,
  duration: 0.6
},
{
  yPercent: 0,
  duration: 0.6
}, "-=0.5");
coSectionTwoTl.fromTo('.co-home-section-two-h3-span-6', {
  yPercent: 150,
  duration: 0.6
},
{
  yPercent: 0,
  duration: 0.6
}, "-=0.5");
// ==========
ScrollTrigger.create({
  trigger: ".co-home-section-two",
  toggleActions: "restart none none reverse",
  start: "30% bottom",
  end: "30% top",
  // markers: true,
  animation: coSectionTwoTl
});
gsap.to('.co-home-section-two-img-bottom', {
    scrollTrigger: {
    trigger: ".co-home-section-two",
    toggleActions: "play none none reverse",
    start: "bottom bottom",
    end: "bottom top"
  },
  opacity: 1,
  duration: 0.3
});
gsap.to('.co-home-section-two-img-top', {
    scrollTrigger: {
    trigger: ".co-home-section-two",
    toggleActions: "play none none reverse",
    start: "bottom bottom",
    end: "bottom top"
  },
  opacity: 0,
  duration: 0.3
});
/*
gsap.to('#co-home-section-two-right', {
    scrollTrigger: {
    trigger: ".co-home-section-two",
    toggleActions: "play none none reverse",
    start: "top bottom",
    end: "bottom top",
    scrub: true
  },
  left: "-20%"
});
gsap.to('#co-home-section-two-left', {
    scrollTrigger: {
    trigger: ".co-home-section-two",
    toggleActions: "play none none reverse",
    start: "top bottom",
    end: "bottom top",
    scrub: true
  },
  bottom: "-40%"
});
gsap.to('#co-home-section-two-right-2', {
    scrollTrigger: {
    trigger: ".co-home-section-two",
    toggleActions: "play none none reverse",
    start: "top bottom",
    end: "bottom top",
    scrub: true
  },
  top: "-40%"
});
*/
gsap.set('#co-home-section-two-h2', {opacity: 0});
gsap.to('#co-home-section-two-h2', {
    scrollTrigger: {
    trigger: ".co-home-section-two",
    toggleActions: "play none none reverse",
    start: "30% bottom",
    end: "30% top"
  },
  opacity: 1,
  duration: 1
});

/* ======================================================== */
/* SECTION THREE */
/* ======================================================== */
gsap.set('.co-home-section-three-h2', {opacity: 0});
gsap.to('.co-home-section-three-h2', {
    scrollTrigger: {
    trigger: ".co-home-section-three",
    toggleActions: "play none none reverse",
    start: "30% bottom",
    end: "30% top"
  },
  opacity: 1,
  duration: 1
});
//=================
/*
gsap.to('.co-home-section-three-front', {
    scrollTrigger: {
    trigger: ".co-home-section-three",
    start: "top bottom",
    end: "bottom top",
    scrub: true
  },
  top: "-10%"
});
*/
gsap.to('.co-home-section-three-back', {
    scrollTrigger: {
    trigger: ".co-home-section-three",
    start: "top bottom",
    end: "bottom top",
    scrub: true
  },
  bottom: "-10%"
});
//=================
let coHomeSectionThreeTl = gsap.timeline();
coHomeSectionThreeTl.fromTo('.co-home-section-three---text-1', {
  yPercent: 150,
  duration: 0.6
},
{
  yPercent: 0,
  duration: 0.6
});
coHomeSectionThreeTl.fromTo('.co-home-section-three---text-2', {
  yPercent: 150,
  duration: 0.6
},
{
  yPercent: 0,
  duration: 0.6
}, "-=0.5");
coHomeSectionThreeTl.fromTo('.co-home-section-three---text-3', {
  yPercent: 150,
  duration: 0.6
},
{
  yPercent: 0,
  duration: 0.6
}, "-=0.5");
coHomeSectionThreeTl.fromTo('.co-home-section-three---text-4', {
  yPercent: 150,
  duration: 0.6
},
{
  yPercent: 0,
  duration: 0.6
}, "-=0.5");
// ==========
ScrollTrigger.create({
  trigger: ".co-home-section-three---text-wrapper",
  start: "top bottom",
  end: "bottom bottom",
  toggleActions: "restart none none reverse",
  animation: coHomeSectionThreeTl
});

/* ======================================================== */
/* SECTION FIVE */
/* ======================================================== */

gsap.set('.co-home-section-five-h2', {opacity: 0});
gsap.to('.co-home-section-five-h2', {
    scrollTrigger: {
    trigger: ".co-home-section-five",
    toggleActions: "play none none reverse",
    start: "30% bottom",
    end: "30% top"
  },
  opacity: 1,
  duration: 1
});
//=================
/*
gsap.to('.co-home-section-five-front', {
    scrollTrigger: {
    trigger: ".co-home-section-five",
    start: "top bottom",
    end: "bottom top",
    scrub: true
  },
  top: "-10%"
});
*/
gsap.to('.co-home-section-five-back', {
    scrollTrigger: {
    trigger: ".co-home-section-five",
    start: "top bottom",
    end: "bottom top",
    scrub: true
  },
  bottom: "-10%"
});
//=================
let coHomeSectionFiveTl = gsap.timeline();
coHomeSectionFiveTl.fromTo('.co-home-section-five---text-1', {
  yPercent: 150,
  duration: 0.6
},
{
  yPercent: 0,
  duration: 0.6
});
coHomeSectionFiveTl.fromTo('.co-home-section-five---text-2', {
  yPercent: 150,
  duration: 0.6
},
{
  yPercent: 0,
  duration: 0.6
}, "-=0.5");
coHomeSectionFiveTl.fromTo('.co-home-section-five---text-3', {
  yPercent: 150,
  duration: 0.6
},
{
  yPercent: 0,
  duration: 0.6
}, "-=0.5");
// ==========
ScrollTrigger.create({
  trigger: ".co-home-section-five---text-wrapper",
  start: "top bottom",
  end: "bottom bottom",
  toggleActions: "restart none none reverse",
  animation: coHomeSectionFiveTl
});
/* ======================================================== */
/* SECTION 8 */
/* ======================================================== */
gsap.set('.co-home-section-8-frame', {opacity: 0});
gsap.to('.co-home-section-8-frame', {
    scrollTrigger: {
    trigger: ".co-home-section-8",
    toggleActions: "play none none reverse",
    start: "top bottom",
    end: "top top"
  },
  opacity: 1,
  duration: 1
});
// ======
let coHomeSection8Tl = gsap.timeline();
coHomeSection8Tl.fromTo('.co-home-section-8-h2-span-1', {
  yPercent: 150,
  duration: 0.6
},
{
  yPercent: 0,
  duration: 0.6
});
coHomeSection8Tl.fromTo('.co-home-section-8-h2-span-2', {
  yPercent: 150,
  duration: 0.6
},
{
  yPercent: 0,
  duration: 0.6
}, "-=0.5");
coHomeSection8Tl.fromTo('.co-home-section-8-h2-span-3', {
  yPercent: 150,
  duration: 0.6
},
{
  yPercent: 0,
  duration: 0.6
}, "-=0.5");
coHomeSection8Tl.fromTo('.co-home-section-8-h2-span-4', {
  yPercent: 150,
  duration: 0.6
},
{
  yPercent: 0,
  duration: 0.6
}, "-=0.5");
coHomeSection8Tl.fromTo('.co-home-section-8-h2-span-5', {
  yPercent: 150,
  duration: 0.6
},
{
  yPercent: 0,
  duration: 0.6
}, "-=0.5");
// ==========
ScrollTrigger.create({
  trigger: ".co-home-section-8-content",
  start: "top bottom",
  end: "bottom bottom",
  toggleActions: "restart none none reverse",
  animation: coHomeSection8Tl
});
/* ======================================================== */
/* SECTION SIX */
/* ======================================================== */
ScrollTrigger.matchMedia({
  "(min-width: 767px)": function() {
    gsap.utils.toArray(".co-slides-wrapper").forEach((panel, i) => {
      ScrollTrigger.create({
        trigger: panel,
        start: "top top", 
        pin: true, 
        pinSpacing: false
      });
    });
  }
}); 
/* ======================================================== FUNCTION ======================================================== */
// SCROLL TRIGGER
function coScrollTriggerAnimation1(coMarker, coTarget, coTrigger, coYPercent, coXPercent, coScale, coYPercentMob, coXPercentMob, coScaleMob, coStart, coEnd) {
  let target = document.querySelectorAll(coTarget);
  let trigger = document.querySelectorAll(coTrigger);
  ScrollTrigger.matchMedia({
    "(min-width: 768px)": function() {
      gsap.to(target, {
          scrollTrigger: {
          trigger: trigger,
          start: coStart,
          end: coEnd,
          markers: coMarker,
          scrub: true
        },
        yPercent: coYPercent,
        xPercent: coXPercent,
        scale: coScale
      });
    }
  });
  ScrollTrigger.matchMedia({
    "(max-width: 767px)": function() {
      gsap.to(target, {
          scrollTrigger: {
          trigger: trigger,
          start: coStart,
          end: coEnd,
          markers: coMarker,
          scrub: true
        },
        yPercent: coYPercentMob,
        xPercent: coXPercentMob,
        scale: coScaleMob
      });
    }
  });
};
coScrollTriggerAnimation1(
  false,
  ".co--case-latest--hero--bg-image", 
  ".co--case-latest--hero", 
  -10, 0, 1.05, 
  -10, 0, 1.05, 
  "top top", 
  "bottom top"
);
coScrollTriggerAnimation1(
  false,
  ".co--case-latest--section-two-back", 
  ".co--case-latest--section-two", 
  0, 0, 1.1, 
  0, 0, 1.1, 
  "top bottom", 
  "bottom top"
);
coScrollTriggerAnimation1(
  false,
  ".co--case-template--slider-one--bg-image", 
  ".co--case-template--slider-one", 
  -10, 0, 1.05, 
  -10, 0, 1.05, 
  "top bottom", 
  "bottom top"
);
// coScrollTriggerAnimation1(
//   false,
//   ".co--case-template--section-four--left--image", 
//   ".co--case-template--section-four", 
//   0, 0, 1.1, 
//   0, 0, 1.1, 
//   "top bottom", 
//   "bottom top"
// );
coScrollTriggerAnimation1(
  false,
  ".co--services--hero--center-image-img-img", 
  ".co--services--section-one", 
  -50, -50, 1.1, 
  -50, -50, 1.1, 
  "top top", 
  "bottom top"
);
// DRAGGABLE
Draggable.create(".co-draggable", {type:"x,y", edgeResistance:0.65, bounds:".co--mood--hero"});
// ===============================================================================================
/* ======================================================== */
/* ABOUT + CONTACT – SECTION TWO */
/* ======================================================== */
gsap.to('.co-about-section-two-img', {
    scrollTrigger: {
    trigger: ".co-about-section-two",
    start: "top bottom",
    end: "bottom top",
    scrub: true
  },
  yPercent: -20,
  scale: 1.4
});
coScrollTriggerAnimation1(
  false,
  ".co-about-section-three-img-1", 
  ".co-about-section-three", 
  0, 0, 0.9, 
  0, 0, 0.9, 
  "top bottom", 
  "bottom top"
);
coScrollTriggerAnimation1(
  false,
  ".co-about-section-three-img-2", 
  ".co-about-section-three", 
  0, 0, 0.9, 
  0, 0, 0.9, 
  "top bottom", 
  "bottom top"
);
coScrollTriggerAnimation1(
  false,
  ".co-casestudies-hero-left-wrapper-img", 
  ".co-casestudies-hero", 
  0, 0, 1.1, 
  0, 0, 1.1, 
  "top top", 
  "bottom top"
);
coScrollTriggerAnimation1(
  false,
  ".co-about-hero-right-wrapper-img", 
  ".co-about-hero", 
  0, 0, 1.1, 
  0, 0, 1.1, 
  "top bottom", 
  "bottom top"
);
// ===============================================================================================